import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getCurrentVariant } from '../../../../../helpers/getCurrentVariant';
import {
  getCurtainRailHexColour,
  getRollerHexColour,
} from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const FrontRollLightGuardRollerBlind = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const patternUrl = getPatternImages(state);
    const currentVariant = getCurrentVariant(state.context);

    const currentProduct = currentVariant
      ? state.context.products.find(product =>
          product.variants.find(variant => variant.id === currentVariant.id),
        )
      : '';

    const bracketColourTag = currentProduct
      ? currentProduct.tags
          .find(tag => tag.includes('Bracket Colour'))
          ?.replace('Bracket Colour:', '')
      : '';

    const bracketColour =
      typeof bracketColourTag === 'string' && bracketColourTag !== ''
        ? bracketColourTag.trim()
        : 'Silver';

    const bracketColourHex = getRollerHexColour(bracketColour);

    const bottomRailColour = state.context.custom.bottomRailColour
      ? state.context.custom.bottomRailColour
      : 'Silver';

    const bottomRailColourHex = getRollerHexColour(bottomRailColour);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.33 409.05"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="rollerFrontRollLightGuard"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={-981.68}
            y1={793.75}
            x2={-981.68}
            y2={811.81}
            gradientTransform="matrix(1 0 0 -1 1258.86 821.84)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <style>
            {
              '.prefix__cls-1{fill:#afafaf}.prefix__cls-3{fill:url(#rollerFrontRollLightGuard)}'
            }
          </style>
        </defs>
        <path
          fill={bracketColourHex}
          d="M0 0h14.55v409.05H0zM539.72.03h14.55v409.05h-14.55z"
        />
        <path
          fill="url(#rollerFrontRollLightGuard)"
          d="M10.18 10.03H544.3v252.59H10.18z"
        />
        <path
          fill="url(#rollerFrontRollLightGuard)"
          d="M10.19 261.51v7.87h533.97v-7.87H10.19v.06"
        />
        <path
          fill="url(#prefix__linear-gradient)"
          d="M10.06 10.03H544.3v18.06H10.06z"
        />
        <path
          fill={bracketColourHex}
          d="M535.26 0v.76h13.3V9h-1.24v9.4h-1.24v-6.59a1.8 1.8 0 00-1.8-1.8v22.87a1.8 1.8 0 001.82-1.78v-6.47h2.49v4.76h2a.68.68 0 00.68-.68V0zM3 0v28.71a.69.69 0 00.68.68h2v-4.76h2.46v6.47A1.81 1.81 0 0010 32.88V10a1.79 1.79 0 00-1.8 1.8v6.6H6.93V9H5.68V.76H19V0z"
          transform="translate(0 .03)"
        />
      </svg>
    );
  },
);
